import MuiToastAlert from "./MuiToastAlert";

export default MuiToastAlert;
